module.exports = __webpack_public_path__ + "static/media/RecomendaCompacto.6caafece.png";